"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var WORKFLOWS_BASE = 'extensions/ecomm/v1/workflows';

var EcommerceWorkflowsApi =
/*#__PURE__*/
function () {
  function EcommerceWorkflowsApi() {
    (0, _classCallCheck2.default)(this, EcommerceWorkflowsApi);
  }

  (0, _createClass2.default)(EcommerceWorkflowsApi, null, [{
    key: "getWorkflowIds",
    value: function getWorkflowIds() {
      return _apiClient.default.get("" + WORKFLOWS_BASE);
    }
  }, {
    key: "createEmbeddedWorkflow",
    value: function createEmbeddedWorkflow(emailType) {
      return _apiClient.default.post(WORKFLOWS_BASE + "/" + emailType);
    }
  }]);
  return EcommerceWorkflowsApi;
}();

exports.default = EcommerceWorkflowsApi;
module.exports = exports.default;